import { ActionType, PayloadToggleType, ToggleModalType } from './types';

export const toggleModal = (payload: PayloadToggleType): ToggleModalType => ({
  type: ActionType.Toggle,
  payload,
});

export const placeholder = '';
